<template>
  <v-autocomplete
    class="selector-empresa"
    id='selector-empresa'
    autocomplete="off"
    label="Empresa" 
    :value="value"
    :items="displayedItems"
    :item-text="getItemText"
    :item-value="item_val"
    :return-object="return_obj"
    hide-details
    @input="myInput"
    @change="myChange"
    @focusin.native="hasLoadedItems = !readonly"
    :readonly="readonly"
    rounded
    solo
  >
    <template v-slot:prepend>
        <label class="label-selector-empresa">{{getLabel()}}</label>
    </template>
  </v-autocomplete>
</template>

<script>
export default  {
  name: 'SelectorEmpresa',
  props: {
    value: {
        type: [Object,Number],
        required: false
    },
    items:{
        type: Array,
        required: true
    },
    lazyItems: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      required: true
      },
    translate: {
      type: Boolean,
      required: false,
      default: false
      },
    return_obj: {
      type: Boolean,
      required: false,
      default: true
      },
    item_val: {
      type: String,
      required: false,
      },
    },
    data() {
      return { hasLoadedItems: false }
    },
    computed: {
      displayedItems() {
        if (!this.lazyItems || this.hasLoadedItems) return this.items
        return this.value && typeof this.value === 'object' ? [this.value] : []
      }
    },
    methods:{
      myInput(val){
        this.$emit('gotInput',val)
      },
      myChange(){
        this.$emit('changed')
      },
      getItemText(item) {
        // Informar de empresa archivada en el texto mostrado en el autocomplete
        if (item.is_archived) return '(Archivada) - ' + item.name
        else return item.name
      },
      getLabel(){
        if(this.translate){
          return this.$t("SelectorEmpresa.company")
        }
        return "Empresa"
      }
    },
}
</script>

<style scoped>
.selector-empresa >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.1) !important;
  padding-right: 5px !important;
}
.selector-empresa >>> .v-input__icon--append {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: rgba(245, 245, 245, 0.1) !important;  
}

.label-selector-empresa {
  font-size: 14px;
  font-weight: 600;
  padding-top: 5px;
  margin-right: 0px;
}
</style>
